import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7d0bd6b4 = () => interopDefault(import('../pages/acknowledgement.vue' /* webpackChunkName: "pages/acknowledgement" */))
const _27217255 = () => interopDefault(import('../pages/active-queues.vue' /* webpackChunkName: "pages/active-queues" */))
const _7b18f907 = () => interopDefault(import('../pages/customer-feedback-layout.vue' /* webpackChunkName: "pages/customer-feedback-layout" */))
const _42f83bd9 = () => interopDefault(import('../pages/customer-feedback-one.vue' /* webpackChunkName: "pages/customer-feedback-one" */))
const _0f764779 = () => interopDefault(import('../pages/ended-queues.vue' /* webpackChunkName: "pages/ended-queues" */))
const _ddd83294 = () => interopDefault(import('../pages/feedback-acknowledgement.vue' /* webpackChunkName: "pages/feedback-acknowledgement" */))
const _776988e0 = () => interopDefault(import('../pages/help-function.vue' /* webpackChunkName: "pages/help-function" */))
const _13c2878e = () => interopDefault(import('../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _5a2720c0 = () => interopDefault(import('../pages/missed-queues.vue' /* webpackChunkName: "pages/missed-queues" */))
const _7beab19c = () => interopDefault(import('../pages/queue-details.vue' /* webpackChunkName: "pages/queue-details" */))
const _5a94d04b = () => interopDefault(import('../pages/rate-our-service.vue' /* webpackChunkName: "pages/rate-our-service" */))
const _3f157273 = () => interopDefault(import('../pages/search-queues.vue' /* webpackChunkName: "pages/search-queues" */))
const _7b1c8bb0 = () => interopDefault(import('../pages/service-dashboard.vue' /* webpackChunkName: "pages/service-dashboard" */))
const _1ee0b998 = () => interopDefault(import('../pages/stored-queues.vue' /* webpackChunkName: "pages/stored-queues" */))
const _1df9393a = () => interopDefault(import('../pages/toggle-call.vue' /* webpackChunkName: "pages/toggle-call" */))
const _4d45507e = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/acknowledgement",
    component: _7d0bd6b4,
    name: "acknowledgement"
  }, {
    path: "/active-queues",
    component: _27217255,
    name: "active-queues"
  }, {
    path: "/customer-feedback-layout",
    component: _7b18f907,
    name: "customer-feedback-layout"
  }, {
    path: "/customer-feedback-one",
    component: _42f83bd9,
    name: "customer-feedback-one"
  }, {
    path: "/ended-queues",
    component: _0f764779,
    name: "ended-queues"
  }, {
    path: "/feedback-acknowledgement",
    component: _ddd83294,
    name: "feedback-acknowledgement"
  }, {
    path: "/help-function",
    component: _776988e0,
    name: "help-function"
  }, {
    path: "/logout",
    component: _13c2878e,
    name: "logout"
  }, {
    path: "/missed-queues",
    component: _5a2720c0,
    name: "missed-queues"
  }, {
    path: "/queue-details",
    component: _7beab19c,
    name: "queue-details"
  }, {
    path: "/rate-our-service",
    component: _5a94d04b,
    name: "rate-our-service"
  }, {
    path: "/search-queues",
    component: _3f157273,
    name: "search-queues"
  }, {
    path: "/service-dashboard",
    component: _7b1c8bb0,
    name: "service-dashboard"
  }, {
    path: "/stored-queues",
    component: _1ee0b998,
    name: "stored-queues"
  }, {
    path: "/toggle-call",
    component: _1df9393a,
    name: "toggle-call"
  }, {
    path: "/",
    component: _4d45507e,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
